import { HttpMethod, PaginatedResponse, Type } from "@/Utils/request/types";

import {
  MVPImmunizationRecord,
  MVPImmunizationRecordCreate,
} from "./immunization";

export default {
  list: {
    path: "/api/v1/facility/{facilityId}/mvp/clinical/immunizations/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPImmunizationRecord>>(),
  },
  create: {
    path: "/api/v1/facility/{facilityId}/mvp/clinical/immunizations/",
    method: HttpMethod.POST,
    TRes: Type<MVPImmunizationRecord>(),
    TBody: Type<MVPImmunizationRecordCreate>(),
  },
} as const;
